// src/pages/AuthCallbackInstagram.jsx
import React, { useEffect } from "react";
import reqInstagram from "../../services/reqMultiTenant/reqInstagram";

const AuthCallbackInstagram = () => {
	useEffect(() => {
		const handleAuth = async () => {
			try {
				const params = new URLSearchParams(window.location.search);
				const code = params.get("code");
				const state = params.get("state");

				if (!code) return;

				try {
					// 	// Aqui você troca o code pelo token
					const responseToken = await reqInstagram.Token(code, state);

					// 	// Atualiza status como conectado
					await reqInstagram.UpdateStatus({
						id_instagram: state,
						status_conexao: "CONNECTED",
					});
				} catch (error) {
					await reqInstagram.UpdateStatus({
						id_instagram: state,
						status_conexao: "DISCONNECTED",
					});
					console.error("Erro ao trocar código por token:", error.response?.data || error.message);
				}
				// if (window.opener) {
				// 	window.opener.postMessage({ source: "instagram-login", code, state }, "*");
				// 	window.close();
				// }
			} finally {
				window.location.href = "/confirmation";
				// console.error("Erro no callback do Instagram:", error);
				// window.close();
			}
		};

		handleAuth();
	}, []);

	return <h2>Processando login do Instagram...</h2>;
};

export default AuthCallbackInstagram;
